import { fromJS } from "immutable";

import { canvasPathActions } from "actions/canvasPathActions.js";

const initialState = fromJS({
    isLoading: true,
    hasErrors: false,
    data: {
        buyplan_id: null,
        filename: null
    }
});

export default (state = initialState, action) => {
    switch (action.type) {
        case canvasPathActions.startLoader:
            return state.set("isLoading", true);
        case canvasPathActions.reset:
            return initialState;
        case canvasPathActions.success:
            return state.merge({
                isLoading: false,
                hasErrors: false,
                data: fromJS(action.payload.data)
            });
        case canvasPathActions.failure:
            return state.merge({
                isLoading: false,
                hasErrors: true,
                data: fromJS(action.payload.data)
            });
        default:
            return state;
    }
};
